import React, { useContext } from 'react';
import gql from 'graphql-tag';
import { useQuery, useMutation } from '@apollo/react-hooks';
import AssessmentTemplateList from './AssessmentTemplateList';
import { parse, filterPaginationWithSize, emptyConnection } from '../../../utils/UrlUtil';
import { useLocation } from "react-router-dom";
import { AccountContext } from '../../../components/AccountContext';
import { NotificationContext } from '../../../components/GrowlNotifications';

export const LIST_QUERY = gql`
  query listAssessmentTemplates(
    $accountId: ID!
    $first: Int
    $after: String
    $last: Int
    $before: String
    $filter: AssessmentTemplateFilter
    $sort: AssessmentTemplateSortSpecifier
  ) {
    account(id: $accountId) {
      id
      assessmentTemplates(first: $first, after: $after, last: $last, before: $before, filter: $filter, sort: $sort) {
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
        totalCount
        indexFrom
        indexTo
        edges {
          cursor
          node {
            id
            title
            createdOn
            updatedOn
            behaviorDimensions
            cognitiveDimensions
            interestsDimensions
            canDelete
          }
        }
      }
    }
  }
`;

const DELETE_TEMPLATE = gql`
  mutation deleteAssessmentTemplate($input: DeleteAssessmentTemplateInput!) {
    deleteAssessmentTemplate(input: $input) {
      clientMutationId
      assessmentTemplateId
    }
  }
`;

const AssessmentTemplates = ({ children, variables }) => {
  const { loading, data, error } = useQuery(LIST_QUERY, {
    variables,
    fetchPolicy: 'network-only',
  });

  const [deleteTemplateMutation] = useMutation(DELETE_TEMPLATE, {
    refetchQueries: ['listAssessmentTemplates'],
  });

  return children({
    assessmentTemplates: { loading, data, error },
    deleteTemplate: deleteTemplateMutation,
  });
}

const AssessmentTemplatesContainer = () => {
  const location = useLocation();
  const currentAccount = useContext(AccountContext);
  const growl = useContext(NotificationContext);

  const params = parse(location.search);
  const pagination = filterPaginationWithSize(params);

  const variables = {
    ...pagination,
    accountId: currentAccount,
    sort: params.sort,
    filter: params.filter,
  };
  return (
    <AssessmentTemplates variables={variables}>
      {({ assessmentTemplates: { loading, data, error }, deleteTemplate }) => {
        if (error) {
          growl.show({ severity: 'error', sticky: true, detail: error.message });
        }

        const connection = data && data.account ? data.account.assessmentTemplates : emptyConnection();

        return (
          <AssessmentTemplateList
            connection={connection}
            deleteTemplate={deleteTemplate}
            loading={loading}
          />
        );
      }}
    </AssessmentTemplates>
  );
}

export default AssessmentTemplatesContainer;
